import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Button } from "reactstrap";
import { Modal, } from "react-bootstrap";
import { sendData, defaultHeaders, } from "../../services/auth";

import { useSelector } from "react-redux";
import { uriList } from "../../helpers/config";
import { width, } from "../../helpers";
import { Aguarde, } from '../../helpers/general'
import { confirmSwal, swalError } from "../../helpers/swal";

const InsertContagensItens = (props) => {
  const [contagem, setContagem] = useState(props.data || props.contagem)
  const [contagemItens, setContagemItens] = useState([])
  const [quantidade, setQuantidade] = useState(1)
  const [produto, setProduto] = useState("")
  const [gravando, setGravando] = useState(false)
  const _login = useSelector((state) => state.login);
  const [loaded, setLoaded] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [excluindo, setExcluindo] = useState(false)
  const [exibirTodos, setExibirTodos] = useState(true)
  const [loadingItens, setLoadingItens] = useState(false)
  const [localizacao, setLocalizacao] = useState(null)
  const [nomeProduto, setNomeProduto] = useState(null)
  const [warningProduto, setWarningProduto] = useState(false)

  const primeiroCampo = useRef(null);
  const segundoCampo = useRef(null);
  const terceiroCampo = useRef(null);

  // Função para manipular o evento onKeyDown
  const handleKeyDown = (e, refCampo) => {
    if (e.keyCode === 13) { // 13 é o código da tecla Enter
      refCampo.current.focus();
    }
  };

  useEffect(() => {
    getData()
  }, [])

  const handleFocus = (campoRef) => {
    if (campoRef?.current)
      campoRef.current.select();
  };

  async function handleDeleteItem(item) {
    async function callback(e) {
      if (!e) return
      console.log("InsertContagensItens.handleDeleteItem(callback): ", e)
      setExcluindo(true)
      await axios({
        url: uriList("delContagemItem"),
        method: 'POST',
        headers: defaultHeaders(),
        data: { ...item }
      })
        .then(res => {
          setExcluindo(false)
          console.log("Registro excluido: ", res)
          getData()
          primeiroCampo.current.focus()
        })
        .catch(error => {
          setExcluindo(false)
          console.log("Erro ao excluir registro: ")
          console.log(error)
        })
    }

    if (!excluindo && !gravando)
      confirmSwal({ callback, title: "Confirma a exclusão do item?" });
  }

  async function getData() {
    console.log("InsertContagensItens.getData: ", { contagem, _login })
    setLoaded(false)
    // getProdutos()

    await getContagemItens()

    setLoaded(true)
  }

  async function getContagemItens() {
    console.log("InsertContagensItens.getContagemItens: ", { filtrarLocalizacao: localizacao })
    setLoadingItens(true)
    await sendData({
      uri: uriList("contagemItens"), content: {
        contagemid: contagem?.CONTAGEMID, empresaid: _login?.empresaid,
        usuarioid: exibirTodos ? null : _login?.usuarioid
      }
    })
      .then((res) => {
        console.log("InsertContagensItens.contagemItens: ", res.data);
        if (res.status && parseInt(res.status) > 200) throw new Error();
        setContagemItens(res.data)
      })
      .catch((e) => {
        console.log(e);
        alert("Erro ao obter Localizacoes.\n" + e.message);
      });

    setLoadingItens(false)
  }

  async function getItem() {
    let result = false
    if (produto && contagem?.CONTAGEMID)
      await sendData({ uri: uriList("contagemItens"), content: { referencia: produto, contagemid: contagem?.CONTAGEMID } })
        .then((res) => {
          console.log("InsertContagensItens.getItem: ", res.data);
          if (res.status && parseInt(res.status) > 200) throw new Error();

          result = res?.data?.[0]
        })
        .catch((e) => {
          console.log(e);
          alert("Erro ao obter item.\n" + e.message);
        });

    return result
  }

  async function getProduto() {
    if (produto && !nomeProduto) {
      setWarningProduto(false)
      setNomeProduto(null)
      await sendData({ uri: uriList("estoqueProduto"), content: { referencia: produto } })
        .then((res) => {
          console.log("InsertContagensItens.getProduto: ", res.data);
          if ((res.status && parseInt(res.status) > 200)) throw new Error();

          console.log("InsertContagensItens.getProduto(Nome): ", res?.data?.NOME);
          setNomeProduto(res?.data?.NOME)
          setLocalizacao(res?.data?.LOCALIZACAO)
          handleFocus(segundoCampo)
          setWarningProduto(!res?.data?.NOME)
        })
        .catch((e) => {
          setWarningProduto(true)
          console.log(e);
          alert("Erro ao obter item.\n" + e.message);
        });
    }

    return true
  }

  function focus() {
    primeiroCampo.current.focus()
  }

  async function handlePost(e, isClose) {
    if (e)
      e.preventDefault()

    if (!produto || !localizacao || !quantidade) {
      swalError({ callback: focus, title: "Informe todos os dados!" })
      return false
    }

    //-- Validando se item já incluido
    let itemExiste = contagemItens?.find(item => item.REFERENCIA == produto)
    if (itemExiste) {
      swalError({ callback: focus, title: "Item já incluído(eu)!", text: itemExiste?.REFERENCIA + " - " + itemExiste?.PRODUTO })
      primeiroCampo.current.focus()
      return false
    }

    itemExiste = await getItem()
    //-- Validando se item já incluido por outro usuário
    if (itemExiste) {
      swalError({ callback: focus, title: "Item já incluído(outro)!", text: itemExiste?.USUARIOI + " - " + itemExiste?.REFERENCIA + itemExiste?.PRODUTO + " - " + itemExiste?.QUANTIDADE })
    }

    setGravando(true)
    const _data = {
      produto: produto,
      localizacao,
      quantidade,
      contagemid: contagem?.CONTAGEMID,
      empresaid: _login?.empresaid,
      usuarioid: _login?.usuarioid,
      id: null,
      REFERENCIA: produto,
      PRODUTO: nomeProduto,
      QUANTIDADE: quantidade,
      LOCALIZACAO: localizacao,
    }

    setContagemItens([...contagemItens, _data])

    axios({
      url: uriList("addContagemItem"),
      method: 'POST',
      headers: defaultHeaders(),
      data: _data
    })
      .then(res => {
        setGravando(false)
        console.log("Registro gravado: ", res)
        limparDados()
        if (isClose)
          handleClose()
        else
          getData()

        primeiroCampo.current.focus()
      })
      .catch(error => {
        setGravando(false)
        console.log("Erro ao gravar registro: ")
        console.log(error)
        swalError({ title: "Erro ao gravar registro!", text: error?.message || error })
        limparDados()
      })

    limparDados()
  }

  function limparDados(e) {
    if (e && e.preventDefault)
      e.preventDefault()

    primeiroCampo.current.focus();
    setProduto("")
    setQuantidade(1)
    setLocalizacao("")
    setNomeProduto("")
    setWarningProduto(false)
  }

  function handleClose() {
    if (props.onCloseEv)
      props.onCloseEv()
  }

  return (
    <>
      <Modal
        size={width() == "mobile" ? "sm" : "lg"}
        show={true}
        onHide={handleClose}
        centered
        animation={false}
        backdrop="static"
      >
        <Modal.Header closeButton >
          <Modal.Title>
            <span>Contagem de Itens</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="maxWidth750">
          <div >
            {deleting && <Aguarde legenda={"Aguarde, excluindo registro..."} />}
            {/* {gravando && <Aguarde legenda={"Aguarde, gravando registro..."} />} */}
            <form className={`form g-2 border p-2 needs-validation ${' was-validated '}`} noValidade disabled={loadingItens}
              id="form-upload-documentos" >
              {!props.empresa &&
                <div className="row g-1">
                </div>}
              <div className='row g-1 d-flex'>
                <div className="form-group col-md-4" style={{ marginBottom: width() == "mobile" ? "0px" : "" }}>
                  <label className="m-0 font-90">Produto</label>
                  <input className="form-control" id="produto" ref={primeiroCampo}
                    style={{ borderColor: warningProduto ? "red" : "", }}
                    onKeyDown={(e) => handleKeyDown(e, segundoCampo)} autoFocus={true}
                    onFocus={() => handleFocus(primeiroCampo)}
                    maxLength={12} onBlur={getProduto}
                    type="text" value={produto} onChange={(e) => {
                      setProduto(e?.target?.value?.toUpperCase())
                      setNomeProduto(null)
                    }} required />
                </div>
                {width() == "mobile" &&
                  <div className='col-md-12'>
                    {nomeProduto && <label style={{ fontStyle: "italic" }} className="m-0 font-90 ">{`${(nomeProduto ? nomeProduto : '')}`} {produto && warningProduto && "<Produto não encontrado>"}</label>}
                  </div>}

                <div className="form-group col-md-3">
                  <label className="m-0 font-90">Localização</label>
                  <input ref={segundoCampo}
                    onFocus={() => handleFocus(segundoCampo)}
                    className="form-control" id="localizacao" type="text" value={localizacao}
                    onKeyDown={(e) => handleKeyDown(e, terceiroCampo)}
                    onChange={(item) => setLocalizacao(item?.currentTarget?.value?.toUpperCase())} required />
                </div>

                <div className="form-group col-md-3">
                  <label className="m-0 font-90">Quantidade</label>
                  <input ref={terceiroCampo}
                    onFocus={() => handleFocus(terceiroCampo)}
                    className="form-control" id="number" type="number" value={quantidade} min="1" max="999999" step="1"
                    onKeyDown={(e) => handleKeyDown(e, primeiroCampo)}
                    onChange={(item) => setQuantidade(item.currentTarget.value)} required />
                </div>
                <div className="form-group col-md-2 ">
                  <Button color="success"
                    className={`btn btn-success btn-block ${width() == "mobile" ? "" : "mt-3"}`}
                    title="Gravar registro de contagem"
                    disabled={!loaded || loadingItens || !nomeProduto}
                    onClick={e => { handlePost(e, false) }} style={{ marginRight: "5px" }}>
                    Gravar
                  </Button>
                </div>
              </div>
              {width() != "mobile" && <div className='row g-1 d-flex col-md-12'>
                {nomeProduto && <label style={{ fontStyle: "italic" }} className="m-0 font-90">{`${(nomeProduto ? nomeProduto : '')}`} {produto && warningProduto && "<Produto não encontrado>"}</label>}
              </div>}
              <div className="form-group col-md-12" style={{ marginTop: "10px", }}>
                <div className='row' style={{ overflowY: "auto", maxHeight: width() == "mobile" ? "150px" : "400px", maxWidth: width() == "mobile" ? "300px" : "" }}>
                  <table className="table table-striped table-hover mb-1 rounded " style={{ opacity: excluindo || gravando ? "50%" : "" }}>
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col" style={{ width: "50%" }}>Produto</th>
                        <th scope="col" style={{ width: "10%" }}>Qtdade</th>
                        <th scope="col" >Localizacao</th>
                        <th scope="col" style={{ width: "5%" }}>#</th>
                      </tr>
                    </thead>
                    <tbody >
                      {!contagemItens && <tr>Carregando...</tr>}
                      {contagemItens?.map((contagemItem, index) => {
                        return (<>
                          {(

                            <tr style={{ cursor: "pointer" }} onClick={() => handleDeleteItem(contagemItem)}>
                              <td style={{ width: "50%" }}>{contagemItem?.REFERENCIA + ' - ' + contagemItem?.PRODUTO}</td>
                              <td style={{ width: "10%" }}>{contagemItem?.QUANTIDADE}</td>
                              <td >{contagemItem?.LOCALIZACAO}</td>
                              {!excluindo &&
                                <td style={{ width: "5%" }}
                                  disabled={excluindo || gravando}
                                  onClick={() => handleDeleteItem(contagemItem)}>{<i title="Excluir ítem da contagem" style={{ fontSize: "12px", color: "red" }} className="fa fa-trash" />}</td>}
                            </tr>
                          )}
                        </>
                        )
                      })
                      }
                    </tbody>
                    <tr>
                      <td colSpan="12" className="text-left">
                        Qtd Registros: {contagemItens && contagemItens.length}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body >
        <Modal.Footer>
          <div className="mr-3" style={{ display: "flex flex-end", }}>
            <Button color="warning"
              title="Limpar dados digitados"
              onClick={limparDados}
              style={{ marginLeft: "5px", width: width() == "mobile" ? "50px" : "" }}>
              Limpar
            </Button>
            <Button color="secondary"
              className='ml-1'
              title="Fechar tela de contagem"
              style={{ marginLeft: "5px", width: width() == "mobile" ? "50px" : "" }}
              onClick={handleClose}>
              Fechar
            </Button>
          </div>
        </Modal.Footer>
      </Modal >
    </>
  );
}

export default InsertContagensItens;